class QuickLinks extends HTMLElement {
  constructor() {
    super();

    this.isDown = false;
    this.startX = 0;
    this.currentPosition = 0;
    this.container = this.querySelector('.js-scroll-container');
    this.links = this.querySelectorAll('.js-quick-link');
  }

  connectedCallback() {
    if (!('ontouchstart' in window)) {
      this.initDragScroll();
    }
  }

  initDragScroll() {
    this.container.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.container.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    this.container.addEventListener('mouseup', this.handleMouseUp.bind(this));
    this.container.addEventListener('mousemove', this.handleMouseMove.bind(this));
  }

  handleMouseDown(event) {
    event.preventDefault();

    this.isDown = true;
    this.startX = event.pageX - this.container.offsetLeft;
    this.currentPosition = this.container.scrollLeft;
  }

  handleMouseLeave() {
    this.setLinkAction('auto');

    this.isDown = false;
    this.container.classList.remove('js-swiping');
  }

  handleMouseUp(event) {
    event.preventDefault();

    this.setLinkAction('auto');

    this.isDown = false;
    this.container.classList.remove('js-swiping');
  }

  handleMouseMove(event) {
    if (!this.isDown) return;

    event.preventDefault();

    this.setLinkAction('none');

    const x = event.pageX - this.container.offsetLeft;
    const walk = (x - this.startX);

    this.container.scrollLeft = this.currentPosition - walk;
  }

  setLinkAction(pointer) {
    this.links.forEach(link => link.style.pointerEvents = pointer);
  }
}

customElements.define("quick-links", QuickLinks);
